export default __webpack_public_path__ + "static/whatsappBackgroundImg-966e92788dec5fe700c32bb2a979ddce.png";